export default {
  abandonProduct: 'Abbandona il prodotto',
  abandonProductTips:
    'Promemoria amichevole: Quando confermi [Abbandona il prodotto], distruggeremo il tuo prodotto e non potrà essere recuperato. Il prodotto non verrà restituito al venditore per un rimborso. Si prega di procedere con cautela.',
  finePhotos: 'Fotografia dettagliata',
  ordinaryPhotos: 'Immagine ordinaria',
  expireText: 'Il pacco sta per scadere',
  more: 'Più',
  timeExpand: 'Tempo prolungato',
  guaranteeService: 'Servizio di garanzia',
  noNeed: 'Non necessario',
  'i18n-0000002':
    'Il tuo articolo ha superato il periodo di stoccaggio. Lo conserveremo per altri 28 giorni. Dopo questo periodo, sarà considerato abbandonato ed eliminato di conseguenza.',
  'i18n-0000003':
    'Se hai bisogno di prolungare il periodo di stoccaggio, acquista il servizio a valore aggiunto per lo stoccaggio prolungato entro 28 giorni.',
  'i18n-0000004': 'Data di scadenza dello stoccaggio',
  'i18n-0000016': 'Lo stoccaggio del prodotto è scaduto',
  'i18n-0000019':
    "Prolungamento dello stoccaggio non pagato. L'articolo è considerato volontariamente abbandonato.",
  'i18n-0000023': 'Completato',
  refundTip: 'Dopo la conferma, la quota di deposito verrà rimborsata sul tuo conto.',
  storageEnum: {
    1: 'Magazzino 1, Cina',
    2: 'Magazzino 2, Cina',
  },
  'i18n-00001': `Accetto le modifiche alle informazioni sulla mia dichiarazione fornite da acbuy per ottemperare ai requisiti doganali locali e migliorare le tariffe di sdoganamento. In caso di mancata stipula di un'assicurazione, sarò l'unico responsabile di eventuali responsabilità e conseguenze derivanti dallo sdoganamento.`,
  'i18n-00002': `Non accetto le modifiche. Si prega di dichiarare così com'è. Sarò l'unico responsabile di eventuali responsabilità e conseguenze derivanti dallo sdoganamento.`,
  'i18n-00003': 'Accetto la modifica',
  'i18n-00004': 'Non accetto la modifica',
  'i18n-00005': 'Modifica delle informazioni segnalate',
  'i18n-00006':
    'Ogni contenuto informativo della dichiarazione deve essere superiore a 25 caratteri. Si prega di modificare e inviare nuovamente',
  'i18n-00007':
    'Calcolato in base al peso reale o volumetrico, prendendo quello maggiore. Eventuali differenze saranno rimborsate o addebitate entro 72 ore dall’imballaggio.',
  'i18n-00008':
    'Per ogni messaggio dichiarato il contenuto deve essere inferiore a {length} caratteri',
  'i18n-00009':
    '{AI} ha ancora servizi a valore aggiunto non pagati. Per conservarli, completa il pagamento e attendi il termine del servizio prima di inviare il pacco. Se scegli di inviare il pacco ora, il sistema annullerà automaticamente i servizi a valore aggiunto corrispondenti che non sono ancora stati pagati.',
}
